import React from 'react';
import Markup from "interweave";

const ExecutiveItem = ({item}) => (
  <div className="staff--item padding__16 background__mist">
    <div className="grid">
      <div className="col-8"><h3 className="heading heading__medium">{item.title}</h3><p>{item.position}</p></div>
      <div className="col-4">
        <div className="staff--item--image">
          <img
            className="image-replace" alt=""
            src={item.image.trim() !== '' ? item.image.trim() : '/themes/nhs/placeholder.jpg'} />
        </div>
      </div>
    </div>
  </div>
);

export default ExecutiveItem;
